import { themeOptionFactory as mobile } from "./mobile"
import { themeOptionFactory as kioskV } from "./kiosk-v"

export const themeOptionFactories = {
  mobile,
  "kiosk-h": null,
  "kiosk-v": kioskV,
}
